<template>
  <div>
    <v-chip class="ml-2" small v-if="!requirement.referenced && requirement.state === 'EDIT'" color="red" dark>
      {{ $t("requirement.awaitingEdit") }}
    </v-chip>

    <v-chip class="ml-2" small v-if="!requirement.referenced && requirement.state === 'AUDIT'" color="green" dark>
      {{ $t("requirement.edited") }}
    </v-chip>

    <v-chip class="ml-2" small v-if="requirement.referenced" color="green" dark>
      {{ $t("requirement.referenced") }}
    </v-chip>
  </div>
</template>

<script>
export default {
  props: {
    requirement: {
      type: Object,
      required: true,
    },
  },
};
</script>
